<template>
  <div class="list">
    <header  class="list__header" color="#16336E" >{{list_name}}</header>
    <ul style="padding-left:10px;">
      <v-list-item-subtitle v-if="proposals.length !== 0">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          single-line
          x-small
          :label="$t('BsList.search_name')"
          color="#15336d"
        ></v-text-field>
      </v-list-item-subtitle>
      <v-spacer style="height:10px;"></v-spacer>
      <div  v-for="(item, index) in (saveProposal.length > 0 ? saveProposal : proposals)" :key="index">
        <li class="d-flex justify-space-between align-center" :style="{background: item.color}">
          <div @click.stop="open_proposal_card(item.id)" style="width: 100%;" >
            <strong> №{{item.id}} {{item.name ? item.name: $t('BsList.application_not_specified')}} </strong><br>
            <v-chip
              class=""
              color="#15336d"
              label
              dark
              x-small>
              <v-icon left x-small>mdi-account-circle-outline</v-icon>
              {{item.author}}
            </v-chip>
            <br>  
            <v-icon left x-small>mdi-calendar</v-icon><i style="font-size:10px">от {{g.toDate(item.date_income)}}</i> <br>
          </div>
        </li>
        <v-spacer></v-spacer>
    </div>
    </ul>
    <footer style="padding-top:15px; padding-bottom:10px;" > 
      <v-progress-linear
          v-if="proposals.length === 0 && !noDataProposals"
          indeterminate
          color="#16336E"
        ></v-progress-linear>
      <template v-else>
        <template v-if="!disabledLoadYet">
          <v-badge
            :value="hover"
            color="#16336E"
            :content="$t('BsList.load_more_applications')"
            right
            transition="slide-x-transition"
          >
            <v-hover v-model="hover">
              <v-btn fab x-small dark color="#16336E" style="margin-right:5px;" @click="showMoreProposals()">
                <v-icon> mdi-arrow-right-bold</v-icon>  
              </v-btn>
            </v-hover>
          </v-badge>
        </template>
        <v-chip
          v-if="noDataProposals"
          style="width:100%"
          color="blue-grey lighten-2"
          outlined
        >
          <v-icon left>mdi-emoticon-sad</v-icon>
          {{$t('BsList.no_applications')}}
        </v-chip>
      </template>
    </footer>

  </div>
</template>

<script>

import { mapActions, mapMutations, mapGetters } from 'vuex'

export default {
    props: {
      list_name: [String, Number],
      status_id: Number,
    },
    components: {
    },
    name: 'ListProposalsCommon',
    data: () => ({
        call_id: null,
        active: true,
        search: '',
        saveProposal: [],
        dialogCard: false,
        dialog: false,
        selected: [],
        proposals: [],
        allProposals: [],
        exper: '',
        disabledExper: true,
        disabledExperButton: true,
        timeout:2000,
        disabledExperSwitch:'',
        currentSlug: '',
        noDataProposals: false,
        page: 1,
        disabledLoadYet: true,        // отображение кнопки загрузить больше заявок
        hover: false,
        pageCount : 1
    }),

    computed: {
      ...mapGetters([
        'GETTERS_CURRENT_STATION',
        'GETTERS_NEED_RELOAD_CLOSE_PROPOSAL',
        'GETTERS_NEED_RELOAD_PROPOSAL_LIST',
      ])
    },

    methods:{
      ...mapActions([
        'GET_LIST_ROLE_NEW',
      ]),
      ...mapMutations([
        'SHOW_PROPOSAL_CARD',
      ]),

      open_proposal_card(id) {
        this.call_id = new Date()
        this.SHOW_PROPOSAL_CARD({
          'proposal_id' : id,
          'call_id': this.call_id
        })
      },


      async loadListProposals(status_id) {
        
        if (status_id !== undefined) {
          var args = {
            status_id: status_id,
            page: this.page,
            station_id: this.GETTERS_CURRENT_STATION
          }

          await this.GET_LIST_ROLE_NEW(args)
          .then(res => {
            var list = res.data

            this.proposals = list;
            this.allProposals = list;
            if (list.length !== 0) {
              this.noDataProposals = false
              this.pageCount = Math.ceil((this.allProposals.length)/10);
              if (this.pageCount > 1){
                this.disabledLoadYet = false;
                this.proposals = this.allProposals.slice(0,10);
              }
              else       
                this.disabledLoadYet = true;
            }
            else{
              this.noDataProposals = true
            }
          })
        }
      },

      showMoreProposals(){
        this.page++;
        this.proposals = this.allProposals.slice(0,(this.page*10));
        if(this.pageCount == this.page){
          this.disabledLoadYet = true; 
        }
      },

    },

    async beforeMount() {
      this.loadListProposals(this.status_id)
    },

    watch: {
      GETTERS_CURRENT_STATION(val){
        if(val){
          this.loadListProposals(this.status_id)
        }
      },
    
      GETTERS_NEED_RELOAD_CLOSE_PROPOSAL(val){
        if(val && val == this.call_id){
            this.loadListProposals(this.status_id)
        }
      },

      GETTERS_NEED_RELOAD_PROPOSAL_LIST(val){
        if(val){
          this.loadListProposals(this.status_id)
        }
      },

      search(val) {
        if (val.length === 0) {
          this.saveProposal = []
        }
        else{
          this.saveProposal = this.allProposals.filter(item => {
            if (item.name !== null) {
              return item.name.toLowerCase().includes(val.toLowerCase())
            }
          })
        }
      },


    }
};

</script>

<style scoped>
.btn-load-more{
    color: rgb(22, 51, 110);
    border-radius: 0px;
    box-shadow: none;
    width: 100%;
    z-index: 1;
    background-color:#e2e4e6;
}
li{ 
  cursor: pointer;
}
li *{ 
  line-height: 15px !important;
}
li:hover{
  background-color: #eeeeee;

}
.v-list-item{
  padding: 0px 0px;
}
.list__header {
  line-height: 1.2;
  padding-top: 15px;
}
</style>
